/**
 * The mark that says a field has to be filled in.
 *
 * ## Why it is a component and not an asterisk
 *
 * Because there were two of them. `CompletionForm` wrote
 * `<span className="text-danger-500"> *</span>` and `TechnicianForm` wrote
 * `<span className="text-danger-600">*</span>` — different colours, different
 * spacing, and most forms wrote neither, so on some screens the required
 * fields were marked and on others they were discovered by pressing Save.
 *
 * One mark, one colour, one place to change it.
 *
 * ## Why the asterisk is not the whole story
 *
 * An asterisk is a convention, and a convention has to be taught somewhere.
 * On its own it is also invisible to a screen reader as anything meaningful —
 * it reads as "star", which is noise. So the mark carries a title for the
 * mouse and an `sr-only` word for everyone else, and the input it belongs to
 * should carry `required` so the browser and assistive technology know too.
 *
 * Colour is not doing the work either: the asterisk is a shape, and the word
 * behind it is real text.
 */
export function Required() {
  return (
    <span className="text-danger-600" title="This one has to be filled in">
      <span aria-hidden="true">&nbsp;*</span>
      <span className="sr-only">(required)</span>
    </span>
  );
}

/**
 * The note that explains the convention, for the foot of a form.
 *
 * One per form, not one per field. Somebody reading a form for the first time
 * needs telling once what the marks mean; after that it is furniture.
 */
export function RequiredNote() {
  return (
    <p className="text-xs text-muted-foreground">
      Fields marked <span className="text-danger-600">*</span> have to be filled in.
    </p>
  );
}
